// Copyright 2017 Sorama B.V.

import { Point3f } from "datatypes/SoramaLocalApi";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";

export class SubScanArea {
    constructor() {
        this.numberOfHorizontalSteps = 1;
        this.numberOfHorizontalSteps = 1;
        this.horizontalStep = 0;
        this.verticalStep = 0;
    }

    public numberOfVerticalSteps: number;
    public numberOfHorizontalSteps: number;
    public horizontalStep: number;
    public verticalStep: number;
}

export class ScanArea {
    constructor() {
        this.width = 0;
        this.height = 0;
        this.offsetX = 0;
        this.offsetY = 0;
        this.offsetZ = 0;
    }

    /**
     * Width of the scanning area in meters
     */
    public width: number;

    /**
     * Height of the scanning area in meters
     */
    public height: number;

    /**
     * Middle of the area in meters
     */
    public offsetX: number;

    /**
     * Middle of the area in meters
     */
    public offsetY: number;

    /**
     * Middle of the area in meters
     */
    public offsetZ: number;
}

export class RecordingStep {
    constructor(stepIndex?: number, position?: Point3f, channelSelection?: ChannelSelection) {
        this.stepIndex = stepIndex;
        this.position = position;
        this.channelSelection = channelSelection;
    }

    // Index of this step in the list of steps
    public stepIndex: number;

    // Physical location of this step in steps
    // Deprecated, use position instead
    public stepLocation?: Point3f;

    // Physical location of this step in [m]
    public position?: Point3f;

    // Id of the recording (if any)
    public recordingId?: string;

    //
    public channelSelection?: ChannelSelection;

    public static equals(a: RecordingStep, b: RecordingStep): boolean {
        return (
            a.stepIndex === b.stepIndex &&
            a.stepLocation.X === b.stepLocation.X &&
            a.stepLocation.Y === b.stepLocation.Y &&
            a.stepLocation.Z === b.stepLocation.Z &&
            a.recordingId === b.recordingId &&
            a.channelSelection === b.channelSelection
        );
    }
}

export class UiRecordingStep extends RecordingStep {
    // Progress of measurement duration of this step (0-1)
    public measureProgress?: number;

    // Progress of data acquisition of this step (0-1)
    public dataProgress?: number;

    // Error that occurred in this step (if any)
    public stepError?: string;

    public static clear(step: UiRecordingStep): void {
        step.recordingId = undefined;
        step.measureProgress = 0;
        step.dataProgress = 0;
        step.stepError = undefined;
    }

    public static fromRecordingStep(step: RecordingStep): UiRecordingStep {
        const uiRecordingStep = new UiRecordingStep();

        Object.assign(uiRecordingStep, step);

        // Set UI Properties
        if (uiRecordingStep.recordingId) {
            uiRecordingStep.measureProgress = 1;
            uiRecordingStep.dataProgress = 1;
        } else {
            uiRecordingStep.measureProgress = 0;
            uiRecordingStep.dataProgress = 0;
        }

        return uiRecordingStep;
    }

    public static toRecordingStep(step: UiRecordingStep): RecordingStep {
        return <RecordingStep>{
            stepIndex: step.stepIndex,
            position: step.position,
            stepLocation: step.stepLocation,
            recordingId: step.recordingId,
        };
    }
}
